import React from 'react'

interface Custom {
    children: React.ReactNode,
    className?: string
}

const Layout = ({children, className=""} : Custom) => {
  return (
    <div className={`${className} w-full h-full inline-block z-0 p-5 desktop:p-24`}>
        {children}
    </div>
  )
}

export default Layout